// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f4-zY","colMin":"styles_colMin__W0Nkx"};